import { memo, useState } from "react";
import { Button, ButtonTypes, Modal } from "@clintonelec/react-storybook";
import "Components/ConfigLayout/Network/SecuritySettings/CertificateInfoModal/CertificateInfoModal.less";
import type { SecurityCertificate } from "Interfaces";
import { formatDate } from "@clintonelec/typescriptutils";

type CertificateInfoModalProps = {
	ieeeEnabled?: boolean;
	certificate?: SecurityCertificate;
};

function CertificateInfoModal(props: CertificateInfoModalProps) {
	const { ieeeEnabled, certificate } = props;
	const { name, issuer, subject, validEnd, validStart } = certificate ?? {};
	const [ visible, setVisible ] = useState(false);

	const handleVisibilityChange = (newVisibility: boolean) => {
		setVisible(newVisibility);
	};

	const modalContent = (
		<div className="certificate-info-modal-content">
			<div className="row">
				<span>Issuer:</span> { issuer ?? "Unknown" }
			</div>
			<div className="row">
				<span>Subject:</span> { subject ?? "Unknown" }
			</div>
			<div className="row">
				<span>Valid Through:</span>
				{ validEnd ? formatDate(validEnd, "MM/DD/YYYY") : "" }
				-
				{ validStart ? formatDate(validStart, "MM/DD/YYYY") : "" }
			</div>
		</div>
	);

	return (
		<Modal
			title="Certificate Information"
			modalContent={ modalContent }
			onVisibilityChange={ handleVisibilityChange }
			visible={ visible }
			width={ 400 }
		>
			<Button
				className="cert-button"
				disabled={ !ieeeEnabled || !name }
				htmlType="button"
				type={ ButtonTypes.TERTIARY }
			>
				Info
			</Button>
		</Modal>
	);
}

export default memo(CertificateInfoModal);
